<div class="form-row">
	<form [formGroup]="formGroup" class="w-100">
		<mat-form-field appearance="outline" class="w-100">
			<input
				matInput
				type="text"
				[matAutocomplete]="auto"
				formControlName="elName"
				[placeholder]="'GENERAL.SEARCH_POI' | translate"
			/>
			<mat-autocomplete #auto="matAutocomplete" class="applyStyle">
				<mat-option
					*ngFor="let elFiltered of elListFiltered | async"
					[value]="elFiltered.fullname"
					(click)="select(elFiltered)"
				>
					<span class="image mx-1">
						<img src="{{ helpersService.pathImgsMarkers }}/poi_map.png?v={{ assets_version }}" />
					</span>
					<mat-divider [vertical]="true" class="mr-2"></mat-divider>
					<span>{{ elFiltered.fullname }}</span>
				</mat-option>
			</mat-autocomplete>
		</mat-form-field>
	</form>
</div>
